<script setup lang="ts">
interface Props {
  bg?: 'dark' | 'light' | 'white'
  blurBg?: boolean
  layout?: 'horizontal' | 'vertical'
}

const props = withDefaults(defineProps<Props>(), {
  bg: 'light',
  blurBg: false,
  layout: 'vertical',
})

const { LocalConfigurationStore } = stores()

const dinamicClasses = computed(() => ({
  'bg-blur': props.blurBg,
  [`bg-${props.bg}`]: true,
}))

const dinamicClassesContent = computed(() => ({
  grid: props.layout === 'vertical',
  'flex items-center': props.layout === 'horizontal',
}))
</script>

<template>
  <div
    class="relative rounded-lg p-1 app-card border"
    :class="dinamicClasses"
  >
    <div
      class="app-card-content"
      :class="dinamicClassesContent"
    >
      <div
        v-if="$slots.header"
        class="flex items-center justify-center rounded-md bg-surface-950 text-white app-card-header relative overflow-hidden"
        :class="layout === 'horizontal' ? 'h-full p-2' : 'p-4'"
        :style="{
          'background-color': LocalConfigurationStore?.brokerContext?.preset?.cardHeaderColorHex,
        }"
      >
        <slot name="header" />
      </div>
      <div class="p-2 w-full">
        <slot />
      </div>
    </div>
  </div>
</template>
